import {
  MdArticle,
  MdCameraAlt,
  MdEdit,
  MdOutlineContentCopy,
} from 'react-icons/md';
import {COLOR_BLACK_1} from '../../../config/constants/colorCodes';

export const INPUT_METHOD_REPORT = 'report' as const;
export const INPUT_METHOD_SCREENSHOT = 'screenshot' as const;
export const INPUT_METHOD_TEXT = 'text' as const;
export const INPUT_METHOD_MANUAL = 'manual' as const;

export type InputMethod =
  | typeof INPUT_METHOD_REPORT
  | typeof INPUT_METHOD_SCREENSHOT
  | typeof INPUT_METHOD_TEXT
  | typeof INPUT_METHOD_MANUAL;

export const INPUT_METHODS = [
  {
    id: INPUT_METHOD_REPORT,
    title: '体験記から選考予定を生成',
    description: '体験記の内容からAI解析で選考予定を自動生成できます',
    icon: <MdArticle size={32} fill={COLOR_BLACK_1} />,
  },
  {
    id: INPUT_METHOD_MANUAL,
    title: '手動で入力',
    description: '',
    icon: <MdEdit size={32} fill={COLOR_BLACK_1} />,
  },
  {
    id: INPUT_METHOD_SCREENSHOT,
    title: '画像からAI自動入力',
    description: 'アップロードした画像からAI解析で自動入力できます',
    icon: <MdCameraAlt size={32} fill={COLOR_BLACK_1} />,
  },
  {
    id: INPUT_METHOD_TEXT,
    title: '自由入力テキストからAI自動入力',
    description: 'メールなどのテキストからAI解析で自動入力できます',
    icon: <MdOutlineContentCopy size={32} fill={COLOR_BLACK_1} />,
  },
] as const;

export type InputMethodItem = (typeof INPUT_METHODS)[number];
